module.exports = __webpack_public_path__ + "icomoon-9oU.svg";